import script from "./FormInputSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInputSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormInputSelect.vue?vue&type=style&index=0&id=5fe02530&lang=css"

const __exports__ = script;

export default __exports__